import {onboardCountryService} from '@/services/marketsService'
import {OnboardCountryRequest, OnboardCountryResult} from '@/types/Markets'

export async function onboardCountryUseCase(params: OnboardCountryRequest): Promise<OnboardCountryResult> {
  const response = await onboardCountryService(params)
  return 'data' in response ? response.data : response
}
